import axios from 'axios';
import store from '../store/store';
import { HttpStatusCode } from '../enum/httpStatus.enum';
import { router } from '../main';

axios.interceptors.request.use(
  (config) => {
    // If token is present add it to request's Authorization Header
    if (store.getters.getJWTToken) {
      config.headers.Authorization = `Bearer ${store.getters.getJWTToken}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;
    // logout user if user is unauthorized
    if (response.status === HttpStatusCode.UNAUTHORIZED) {
      localStorage.clear();
      router.push({ path: '/auth' });
    }

    if (response.status === 403) {
      router.push({ name: 'AccessDenied' });
    }

    if (response.status === 404) {
      router.push({ name: 'pageNotFound' });
    }

    return Promise.reject(response);
  }
);

export const axiosPost = (url, data = {}, options = {}) => {
  return axios.post(url, data, options);
};

export const axiosGet = (url, options = {}) => {
  return axios.get(url, options);
};

export const axiosPut = (url, data = {}, options = {}) => {
  return axios.put(url, data, options);
};

export const axiosDelete = (url, data = {}, options = {}) => {
  return axios.delete(url, { data, ...options });
};

export const axiosPatch = (url, data = {}, options = {}) => {
  return axios.patch(url, data, options);
};

export default axios;
